import { deepCopy, getDataScopeByPermission, getForwarderByPermission, isNullOrEmpty, laaSFormatString } from 'src/app/core/utils/common-functions';
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PageInfo } from 'src/app/core/models/page-info';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { FacilityService } from 'src/app/core/services/facility.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { TruckCostAllocationService } from '../../services/truck-cost-allocation.service';
import { ConfirmEventType } from 'primeng/api';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { ContainerService } from '../../services/container-service.service';

@Component({
  selector: 'laas-create-cross-boundry',
  templateUrl: './create-cross-boundry.component.html',
  styleUrls: [ './create-cross-boundry.component.scss']
})
export class CreateCrossBoundryComponent extends SessionBaseComponent implements OnInit {
  @ViewChild('headerTable') dataTable!: DataTableComponent;

  readonly permissionCode = PermissionConstants.EditTruckCostAllocation;

  defaultSearchParams: any;

  @Input() bookingReferenceKeys!: any[];
  @Input() warehousingReferenceKeys!: any[];

  @Output() closeCreateCrossBoundryEvent: EventEmitter<any>;

  createForm: FormGroup;
  searchParams: any;
  forwarderOptions: any[];
  letterHeadOptions: any[];
  orgIdsOptions: any[];
  shipCorpsOptions: any[];
  orgOptions: any[]
  incotermOptions: any[];
  selectedRows: any[] = [];
  deliveryTypeOptions: any[];
  cbTypeOptions: any[];
  carTypeOptions: any[];
  cbMainType: any;
  multipleAddressType: any;
  cbType: any;
  referenceKeysString: string ='';
  crossBoundryNo: string = '';
  isShowCrossBoundryNoDialog: boolean = false;
  noShippingReasonOptions: any[];
  facilityOptions: any[];
  isControlledItemList: any;
  countryOptions: any[];
  fromCityOptions: any[];
  toCityOptions: any[];
  toAreaOptions: any[];
  fromAreaOptions: any[];
  areaAllOptions: any[];

  iscreateFormOpen: boolean = true;
  isSearchFormOpen: boolean = true;
  isCrossBoundryCreating: boolean = false;

  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  sortOrder: SortOrder = {
    property: "createDt",
    direction: -1
  };


  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private dropdownOptionsService: DropdownOptionsService,
    private commonDataService: CommonDataService,
    private containerService: ContainerService,
    private truckCostAllocationService: TruckCostAllocationService,
    private addressMaintainanceService: AddressMaintainanceService,
    private fb: FormBuilder) {
    super(injector);
    this.closeCreateCrossBoundryEvent = new EventEmitter<any>();

    this.searchParams = {
      registrationKey: [],
      referenceType: null,
      referenceKey: [],
      forwarder: null,
      createDtStart: null,
      createDtEnd: null,
      isArrived: null,
      abnormalReference:[],
      dataScopes:null,
      facility:[]
    }

    this.createForm = this.fb.group({
      cbType: [null, Validators.required],
      shipForwarder: null,
      customsForwarder: null,
      createCarType: [null, Validators.required],
      cbMainType: [null, Validators.required],
      fromCountry: null,
      fromCity: null,
      fromArea: null,
      toCountry: null,
      toCity: null,
      toArea: null,
      multipleAddressType:'Normal'
    })

    this.cbTypeOptions = [
      { label: '1.出貨', value: 1 },
      { label: '2.進貨', value: 2 },
      { label: '3.報關', value: 3 },
      { label: '4.出貨+報關', value: 4 },
      { label: '5.進貨+報關', value: 5 },
      { label: '6.本地', value: 6 }
    ];


    this.forwarderOptions = [];
    this.letterHeadOptions = [];
    this.orgIdsOptions = [];
    this.shipCorpsOptions = [];
    this.orgOptions = [];
    this.incotermOptions = [];
    this.deliveryTypeOptions = [];
    this.carTypeOptions = [];

    this.noShippingReasonOptions = [];
    this.pageInfo = { pageSize: 5, pageIndex: 0, totalRecords: 0, totalPages: 0 };
    this.facilityOptions = [];

    this.countryOptions = [];
    this.fromCityOptions = [];
    this.toCityOptions = [];
    this.fromAreaOptions = [];
    this.toAreaOptions = [];
    this.areaAllOptions = [];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.dropdownOptionsService.getLetterOrgOptions()
      .subscribe({
        next: (options: any[]) => {
          this.letterHeadOptions = this.orgIdsOptions = this.shipCorpsOptions = options;
          this.orgOptions = options.map(x => ({ label: x.legalEntityOUName, value: x.legalEntityOUCode }));
        }
      });
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.incotermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });


    this.dropdownOptionsService.getFacilityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

      this.dropdownOptionsService.getForwarderOptions().subscribe({
        next: (options: any[]) => {
          this.forwarderOptions = options.filter((x: any) => {
            return ( this.userProfile.userType === UserType.SuperAdmin.toString() ||
            this.userProfile.userType === UserType.Shipping.toString() ||
            getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
          }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
      this.facilityService.getCountryOptions().subscribe({
        next: result => {
          this.countryOptions = [...result].map((x: any) => {
            return {
              label: `${x.countryCode}-${x.countryName}`,
              value: x.countryCode,
            };
          });
        }
      });

      this.dropdownOptionsService.getRfqCategoryTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.deliveryTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });


      this.facilityService.getCityOptions().subscribe({
        next: result => {
          this.toCityOptions = this.fromCityOptions = [...result].map((x: any) => {
            return {
              label: `${x.name}-${x.enName}`,
              value: x.seqNo.toString(),
              country: x.country
            };
          });
        }
      });

      this.dropdownOptionsService.getAllAreaOptionForHK().subscribe({
        next: result => {
          this.areaAllOptions = [...result].filter((x: any) => x.rfqAreaName && x.rfqAreaCode).map((x: any) => {
            return {
              label: x.rfqAreaName,
              value: x.rfqAreaCode,
              citySeqNo : x.citySeqNo,
            };
          });
        }
      });


      this.containerService.getCarTypeByAllFacility().subscribe({
        next: (result) => {
          this.carTypeOptions = [...result].map((x: any) => {
            return {
              label: `${x.carType} - ${x.carCnDesc}`,
              value: x.carType
            };
          });
        },
      });

      this.referenceKeysString = this.bookingReferenceKeys.join(', ')+this.warehousingReferenceKeys.join(', ');

  }

  resetBtnClick(event: any) {
    this.createForm.reset();
  }

  dateOnChange(date: any,type:string) {
    switch(type){
      case "etd" :
        this.searchParams.etdStart = date.startDate;
        this.searchParams.etdEnd = date.endDate;
        break;
      case "invoiceDt":
        if (!isNullOrEmpty(date.startDate)) {
          this.searchParams.invoiceDateStart = date.startDate.setSeconds(0);
        } else {
          this.searchParams.invoiceDateStart = date.startDate;
        }

        if (!isNullOrEmpty(date.endDate)) {
          this.searchParams.invoiceDateEnd = date.endDate.setSeconds(0);
        } else {
          this.searchParams.invoiceDateEnd = date.endDate;
        }

        break;
    }
  }

  createBtnClick() {

    console.log('params: ' + JSON.stringify(this.createForm.value));
    console.log('bookingReferenceKeys: ' + this.bookingReferenceKeys);
    console.log('warehousingReferenceKeys: ' + this.warehousingReferenceKeys);
    if (this.createForm.invalid) {
      this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFieldsOrFieldsFormat'));
      return;
    }

    if ([1, 2, 4, 5, 6].includes(this.createForm.value.cbType)) {
      if (isNullOrEmpty(this.createForm.controls.shipForwarder.value)) {
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFieldsOrFieldsFormat'));
        return;
      }
    }

    if ([3, 4, 5].includes(this.createForm.value.cbType)) {
      if (isNullOrEmpty(this.createForm.controls.customsForwarder.value)) {
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFieldsOrFieldsFormat'));
        return;
      }
    }

    if ((this.cbMainType === 'CT') ) {
      if (isNullOrEmpty(this.createForm.controls.fromCountry.value) || isNullOrEmpty(this.createForm.controls.toCountry.value)
          || isNullOrEmpty(this.createForm.controls.fromCity.value)|| isNullOrEmpty(this.createForm.controls.toCity.value)) {
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFieldsOrFieldsFormat'));
        return;
      }
    }
    this.isCrossBoundryCreating = true;
    const params = deepCopy(this.createForm.value);
    params.bookingReferenceKeys = this.bookingReferenceKeys;
    params.warehousingReferenceKeys = this.warehousingReferenceKeys;

    if((this.createForm.value.shipForwarder!=this.createForm.value.customsForwarder)
    &&([4, 5].includes(this.createForm.value.cbType))) {
      this.confirmationService.confirm({
        message: this.translateService.instant('因運送貨代與報關貨代不同會產生兩張CB/CT號，是否確認?'),
        header: this.translateService.instant('系統資訊'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.createCrossBoundry(params);
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.isCrossBoundryCreating = false;
              break;
            case ConfirmEventType.CANCEL:
              this.isCrossBoundryCreating = false;
              break;
          }
        }
      });
    } else {
      this.createCrossBoundry(params);
    }
  }


  createCrossBoundry(params:any) {
    console.log("createCrossBoundry 有執行");
    this.truckCostAllocationService.createCrossBoundryMA(params)
    .pipe(finalize(() => this.isCrossBoundryCreating = false))
    .subscribe({
      next: (response) => {
        if (response.flag === 'W') {
          this.toastService.warn(this.translateService.instant('CreateCrossBoundryDialog.Message.MultipleAddressMsg'));
        } else if (response.flag === 'F') {
          this.closeCreateCrossBoundryEvent.emit({ originalEvent: event });
          const crossBoundryNos = response.message;
          console.log(" this.crossBoundryNo  ==" + crossBoundryNos);
          this.toastService.success("創建成功CB/CT:" + crossBoundryNos);
          this.isCrossBoundryCreating = false;
        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  async getCityOptions(country: string): Promise<any[]> {
    var cityOptions: any[] = [];
    cityOptions = await this.addressMaintainanceService.getCityOptions(country);
    cityOptions = cityOptions.map(x => ({
      label: `${x.name}-${x.enName}`,
      value: x.seqNo.toString()
    }));
    return cityOptions;
  }

  async onCountryChange(event: any, type: string): Promise<void> {
    if (type === 'from') {
      if (!isNullOrEmpty(this.createForm.get('fromCountry')?.value)) {
        const fromCountry = this.createForm.get('fromCountry')?.value;
        this.fromCityOptions = await this.getCityOptions(fromCountry);
      }
      if (!isNullOrEmpty(this.createForm.get('fromCountry')?.value) && !isNullOrEmpty(this.createForm.get('fromCity')?.value)) {
        console.log("我有近來from" +this.createForm.get('fromCountry')?.value +this.createForm.get('fromCity')?.value);
        this.fromAreaOptions =  this.areaAllOptions;
        this.fromAreaOptions = this.fromAreaOptions.filter(x => x.citySeqNo?.toString() === this.createForm.get('fromCity')?.value);
      }
    } else if (type === 'to') {
      if (!isNullOrEmpty(this.createForm.get('toCountry')?.value)) {
        const toCountry = this.createForm.get('toCountry')?.value;
        this.toCityOptions = await this.getCityOptions(toCountry);
      }
      if (!isNullOrEmpty(this.createForm.get('toCountry')?.value) && !isNullOrEmpty(this.createForm.get('toCity')?.value)) {
        this.toAreaOptions =  this.areaAllOptions;
        this.toAreaOptions = this.toAreaOptions.filter(x => x.citySeqNo?.toString() === this.createForm.get('toCity')?.value);
      }
    }
  }

}
